<script>
	export default {
		props: {
			assessment: {
				type: Object,
				required: true
			},
			roster: {
				type: Object,
				required: true
			}
		},
		computed: {
			title() {
				const vabka = 'Vocabulary & Background Knowledge Assessment';
				const waata = 'Write About a Topic Assessment';

				const titles = {
					vabka,
					'vabka-post-assessment': vabka,
					waata,
					'waata-post-assessment': waata
				};

				return titles[this.assessment.type];
			}
		}
	};
</script>
<style lang="scss">
	.sra-status-modal {
		.modal-content-header {
			margin-bottom: 0.5rem;
		}

		.results-table {
			thead {
				background: none;
				border-top: none;
			}

			th,
			td {
				padding: 0.6rem 0.75rem;
				line-height: 1.25;
				font-size: 1rem;
			}

			th {
				text-align: left;
				font-weight: 700;
			}
		}
	}
</style>
<template>
	<modal
		id="sra-status-modal"
		class="sra-status-modal">
		<div slot="header-container">
			<h2>{{ title }}</h2>
		</div>
		<div slot="content">
			<table class="results-table">
				<thead>
					<tr>
						<th>Student</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="student in roster"
						:key="student.uid">
						<td>{{ student.firstName }} {{ student.lastName }}</td>
						<td v-if="assessment.suidsSubmitted && student.uid in assessment.suidsSubmitted">Submitted</td>
						<td
							v-else
							class="text-muted">
							Not Submitted
						</td>
					</tr>
				</tbody>
			</table>
			<div class="button-container text-centered">
				<button
					class="button"
					data-modal-close>
					Ok
				</button>
			</div>
		</div>
	</modal>
</template>
